<div class="modal-body pt-5 pb-5 px-4">
  <div class="row mb-4">
    <div class="col-md-12  text-center">
      <h5 class="font-weight-bold text-white">{{ title }}</h5>
    </div>
  </div>
  <div class="row">
    <div class="col-6 text-center">
      <p class="text-white">{{ assignText }}</p>
    </div>
    <div class="col-6 text-center">
      <p class="text-white">{{ userName }}</p>
    </div>
  </div>
  @if (sla) {
    <div class="row">
      <div class="col-6 text-center">
        <p class="text-white">SLA estimado</p>
      </div>
      <div class="col-6 text-center">
        <!-- <p class="text-white">{{ sla }} día<span *ngIf="sla > 1">s</span></p> -->
        <p class="text-white">{{ sla | timeFormatPipe }}</p>
      </div>
    </div>
  }
  <div class="row d-flex justify-content-center">
    <button type="button" class="btn btn-outline-primary bg-white rounded-pill text-dark px-4 font-weight-bold ml-2" (click)="activeModal.dismiss('cancel click')">Aceptar</button>
  </div>
</div>